import { render, staticRenderFns } from "./morf.vue?vue&type=template&id=0bb85848&scoped=true&"
import script from "./morf.vue?vue&type=script&lang=js&"
export * from "./morf.vue?vue&type=script&lang=js&"
import style0 from "./morf.vue?vue&type=style&index=0&id=0bb85848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb85848",
  null
  
)

export default component.exports